import {PageErrorsFactory} from '../Errors/factory.js'
import {GetRemoteUrlRequest} from './GetRemoteUrlRequest.js'

export class PageRequestsFactory {
  static getRemoteUrlRequest = ({items}) => {
    GetRemoteUrlRequest.validate({
      items,
      invalidRemoteRequestError: PageErrorsFactory.getRemoteUrlError
    })

    return new GetRemoteUrlRequest({items})
  }
}
